// document.types._AVAILABLE_DOCUMENT_FEATURES
export type AvailableDocumentFeatures =
    | 'advance'
    | 'bank_details'
    | 'client_balance'
    | 'date_accepted'
    | 'date_cancelled'
    | 'date_confirmed'
    | 'date_due'
    | 'date_paid'
    | 'date_sent'
    | 'date_shipped'
    | 'date_valid'
    | 'hanko'
    | 'hidden_prices'
    | 'hidden_totals'
    | 'message'
    | 'project_name'
    | 'proviso'
    | 'receive_document'
    | 'signature'
    | 'swapped_address'
    | 'tax_registration_number';

// document.types.DOCUMENT_TYPES
export type DocumentType =
    | 'acceptance'
    | 'deliveryslip'
    | 'invoice'
    | 'order'
    | 'orderconfirmation'
    | 'orderslip'
    | 'paymentnotice'
    | 'quote'
    | 'receipt'
    | 'timesheet';

// doty.serializers.DotySerializer
export type Doty = {
    code: DocumentType;
    display_name: string;
    features: Record<AvailableDocumentFeatures, boolean>;
};

export const AvailableDocumentTypes = [
    'acceptance',
    'deliveryslip',
    'invoice',
    'order',
    'orderconfirmation',
    'orderslip',
    'paymentnotice',
    'quote',
    'receipt',
    'timesheet',
    'paymentnotice',
];
